import { Collection } from 'firestorter';

import BaseDocument from '../../Model/BaseDocument';
import Collections from '../../utils/collections';

const RecipePreferenceType = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE',
};

class RecipePreference extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.RECIPE_PREFERENCE}/${id}`, opts);
  }

  get preference() {
    return this.data.preference;
  }

  get recipeId() {
    return this.data.recipeId;
  }

  get reason() {
    return this.data.reason || [];
  }

  static async getRecipePreferences(userId) {
    const recipePreferencesCollection = new Collection(Collections.RECIPE_PREFERENCE, {
      createDocument: (src, opts) => new RecipePreference(src.id, opts),
      query: (ref) => ref.where('userId', '==', userId),
    });
    await recipePreferencesCollection.fetch();
    return recipePreferencesCollection;
  }
}

export { RecipePreferenceType };
export default RecipePreference;
